import { enUS, srLatn } from 'date-fns/locale';
import { AvailableLanguages } from '../enum/AvailableLanguages';

/** 
 * languageLocales: Record mapping supported languages (from AvailableLanguages enum)
 * to their corresponding localization data.

 * Each entry contains:
 *  - localeString: string used for Intl API (e.g., toLocaleDateString, Intl.DateTimeFormat)
 *  - dateFns: locale object imported from date-fns, used for formatting dates in libraries like React DayPicker or date-fns format functions
*/

export const languageLocales = {
  [AvailableLanguages.ENG]: { localeString: 'en-US', dateFns: enUS },
  [AvailableLanguages.SRSR]: { localeString: 'sr-Latn-RS', dateFns: srLatn },
};
